<template>
  <div id="settleInbounds">
    <header-nav :content="`${$t('pages_router_007')} / ${ $t('pages_router_021')}`" />
    <div class="common-card-body">
      <div class="inbounds-header">
        <div class="main-title">{{ $t('pages_pay_001') }}</div>
        <div class="sub-title">{{ $t('pages_pay_002') }}</div>
      </div>
      <div class="inbounds-body">
        <img src="~@/assets/images/settle-inbounds.png" class="main-img">
        <div class="flex-align inbounds-btn">
          <a-button
            shape="round"
            type="primary"
            class="single-btn"
            @click="singleApply"
          >{{ $t('pages_pay_003') }}</a-button>
          <a-button
            shape="round"
            type="primary"
            class="batch-btn"
            @click="$router.push('/funds/inbounds/batch_cny')"
          >{{ $t('pages_pay_004') }}</a-button>
        </div>
        <div style="display: flex;  justify-content: center">
          <div class="payee-choose" :style="{visibility: display ? 'visible' : 'hidden'}">
            <h3>{{ $t('pages_pay_005') }}</h3>
            <div
              v-for="btn in chooseBtns"
              :key="btn.key"
              class="choose-btn"
              :class="activeKey === btn.key ? 'active' : ''"
              @click="chooseBtnClick(btn)"
            >
              <img src="~@/assets/icons/ic-user.png">
              <div class="desc-info">
                <div class="title">{{ btn.title }}</div>
                <div class="desc">{{ btn.desc }}</div>
              </div>
              <down-outlined v-show="btn.selected && !selected" class="ic-select" />
              <up-outlined v-show="btn.selected && selected" class="ic-select" />
            </div>
            <div v-show="selected" class="choose-area">
              <person-select
                ref="selectRef"
                menu-length="688px"
                method-type="inbound"
                @select="menuSelect"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderNav from '@/components/header-nav'
import PersonSelect from '@/components/person-select'
import { useRouter } from 'vue-router'
import { ref, reactive, toRefs } from 'vue'
import i18n from '@/locale'
import { _pay } from '@/api'
export default {
  name: 'SettleInbounds',
  components: {
    'header-nav': HeaderNav,
    'person-select': PersonSelect
  },
  setup () {
    const selectRef = ref(null)
    const router = useRouter()
    const state = reactive({
      display: false,
      selected: false,
      activeKey: '',
      payees: [],
      chooseBtns: [
        { key: 'create', title: i18n.global.t('pages_pay_006'), desc: i18n.global.t('pages_pay_008'), selected: false },
        { key: 'choose', title: i18n.global.t('pages_pay_007'), desc: i18n.global.t('pages_pay_009'), selected: true }
      ]
    })

    const singleApply = () => {
      state.display = true
    }

    const chooseBtnClick = (btn) => {
      state.activeKey = btn.key
      if (btn.selected) state.selected = !state.selected
      else router.push('/funds/inbounds/payee_edit')
    }

    const menuSelect = (payeeId) => {
      state.selected = false
      const query = { payeeId }
      const payee = state.payees.find(item => item.code === payeeId)
      const { businessType } = payee
      if (businessType.indexOf('00') !== -1) query.businessType1 = '00'
      if (businessType.indexOf('01') !== -1) query.businessType2 = '01'
      router.push({ path: '/funds/inbounds/single_cny', query })
    }

    const loadPayeeList = async () => {
      const res = await _pay.getPayeeList({ pageEnable: false, status: '01' })
      if (res.data.succ) {
        state.payees = res.data.data.list.map(item => {
          return Object.assign({}, item, {
            code: String(item.id),
            name: item.payeeName
          })
        })
        selectRef.value.initData('', state.payees)
      }
    }

    loadPayeeList()

    return {
      selectRef,
      menuSelect,
      singleApply,
      chooseBtnClick,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
@import '../styles/pay-page.less';
</style>

